import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Textarea } from "@/components/ui/textarea";
import { clsx } from "clsx";
import {
  AlertCircle,
  BrainCircuit,
  Check,
  CheckCircle2,
  ChevronRight,
  ChevronsRight,
  ClipboardPaste,
  Copy,
  Expand,
  FileJson,
  FileText,
  GraduationCap,
  RefreshCw,
  Rocket,
  X,
  XCircle,
} from "lucide-react";
import { useEffect, useState } from "react";
import { useWebHaptics } from "web-haptics/react";
import { DoubleLineMenuIcon } from "./Icons";

export type Question = {
  id: string;
  question: string;
  options: string[];
  codeBlocks: string[];
  correctAnswerIndex: number;
  explanation?: string;
  difficultyLevel: "Beginner" | "Intermediate" | "Advanced";
};

const DEFAULT_QUESTIONS: Question[] = [];

const SUBJECTS = [
  `
Subject Title: Programming in Python

Unit-1: Introduction and Overview: Overview of Python Programming: Structure of a Python Program, Elements of Python, Python Interpreter, Python shell, Indentation. Atoms, Identifiers and keywords, Literals, Strings.

Unit-2: Operators and Statements: Operators (Arithmetic operator, Relational operator, Logical or Boolean operator, Assignment, Operator, Ternary operator, Bit wise operator, Increment or Decrement operator). Creating Python Programs: Input and Output Statements

Unit-3: Decision making and Branching: Control statements (Branching, Looping, Conditional Statement, Difference between break, continue and pass, default arguments. Defining Functions.

Unit-4: Classes and Objects: An introduction to object-oriented programming in Python. objects, operator overloading, overriding, special methods. Inheritance, polymorphism and composition

Unit-5: Iterators and Generators: Iteration protocol, Inerrable objects, generators and generator expressions. Use of generators, assertions. Testing and debugging of a python project, Web Scrapping in Python.
`,
  `
Subject Title: Unix and Shell Programming

Unit-1: Introduction: History, salient features, Unix system architecture, Unix command
format, Unix internal and external commands, Directory commands, File related
commands, Disk related commands, general utilities. Unix File System: Boot
inode, super and data block, in-core structure, Directories, conversion of
pathname to inode, inode to a new file, Disk block allocation. Process
Management: Process state and data structures of a Process, User vs, kernel
node, context of a Process, background processes, Process scheduling
commands, Process terminating and examining commands.

Unit-2: Secondary Storage Management: Formatting, making file system, checking disk
space, mountable file system, disk partitioning, file compression. Special Tools
and Utilities: Filters, Stream editor SED and AWK, Unix system calls and
library functions, Processes, signals and Interrupts, storage and compression
facilities.

Unit-3: Shell Programming: vi editor, shell types, shell command line processing, shell
script features, executing a shell script, system and user-defined variables, expr
command, shell screen interface, read and Eco statement, command
substitution, escape sequence characters, shell script arguments, positional
parameters, test command, file test, string test, numeric test

Unit-4: Conditional Control Structures-if statement, case statement Looping Control
Structure-while, until, for, statements. Jumping Control Structures – break,
continue, exit.
`,
  `
Subject Title: Accounting and Financial Management

Unit-1: Introduction to Accountancy: definition, objectives, advantages & limitations;
Accounting Principles, Concepts & Conventions, Double entry System; Rules
of Debit & Credit – Modern (American) Approach & Traditional rules (British
Approach), Journal; Accounting equation. Ledger Accounts: Meaning,
classifications, ledger posting from journal entries, ledger posting from Cash
book, Accounting for Cash - Cash book (three column Cash book).

Unit-2: Trial Balance: Meaning, special features and objectives; Preparation of trial
balance, Financial statements (with adjustment): Meaning of Trading, Profit &
Loss a/c and Balance Sheet, Adjustments: Closing stock, outstanding expenses,
prepaid expenses, Accrued income, advance income, bad debts, provision for
bad and doubtful debt, provision for discount on debtors and creditors,
Depreciation, interest on capital, interest on drawing, interest on loans.

Unit-3: Ratio Analysis: Meaning of Accounting ratios, objectives and limitations. Types
of ratios and their usefulness – Liquidity Ratio, Current ratio, Profitability Ratio,
Efficiency ratio, solvency ratios, Stock turnover ratio, Gross Profit Ratio, Net
Profit Ratio, Debit Equity Ratio, Debtors turnover Ratio.

Unit-4: Introduction to Management accounting: Meaning, objectives, nature & scope,
advantages & limitations of Management accounting. Differences between
Financial Accounting and Management Accounting, Management Accounting
and Cost Accounting. Management Accountant’s position, roles and
responsibilities. Standard costing- Meaning, objective, advantages & limitations
of Standard Costing.

Unit-5: Budgeting: Definition, Budget Vs Forecasts, and Essentials of budgeting. Types
of Budget – Functional, Master, Fixed, flexible Budget and zero-based
budget.(Theory and simple problems), Budgetary Control: Meaning, objectives,
advantages and limitations. Unit Costing: Preparation of Cost Sheet and Tender
Price Statement.
`,
  `
Subject Title: Computer Networks

Unit-1: Computer Networks: Introduction to computer network, data communication,
Network components, Uses of networks and Topologies, Categories of Network
(LAN, MAN & WAN), Transmission Media, Trace-route and socket API,
Protocols and layering, Reference models (Internet, OSI), LAN switching
(switch, hubs, Repeater, Bridge, Gateway, Router)

Unit-2: Network Models: Client/ server network and Peer-to-peer network, OSI layers
and functionalities, TCP/IP layers and functionalities. TC/IP Protocol suite.

Unit-3: Addressing and Routing: Logical Addressing- IPv4 Addresses, IPv6 Addresses.
TCP/IP datagram Format, Internet protocol- Internetworking, IPv4, IPv6,
transition from IPv4 to IPv6. Address Mapping- ARP, RARP, BOOTP, DHCP,
Error Reporting- ICMP. Multicasting-IGMP

Unit-4: Network Applications: DNS-Name space, Distribution of name space, DNS in
the Internet, resolution, DDNS. Remote logging- TELNET, Electronic MailSMTP, POP, IMAP, File Transfer- FTP, WWW, HTTP, Network Management:
SNMP.

Unit-5: Network Security: Security services- message confidentiality, message integrity,
Message authentication, Digital signature, Entity authentication, Key
management- Symmetric, Asymmetric. Security in the Internet: IPSec, TLS,
PGP, VPN and Firewalls
`,
  `
Subject Title: Software Engineering

Unit-1: Introduction to Software Engineering: Definition, Software development and
life-cycle models, CMM, Software Quality, role of metrics and measurement.

Unit-2: Requirements Analysis and Specification: SRS Building Process, Specification
Languages, Validation of SRS, metrics, monitoring and control, Object
Oriented analysis.

Unit-3: Software Project Planning: Software Cost Estimation Techniques, Project
Scheduling & Tracking, Project Team Standards, software configuration
management.

Unit-4: Software Design and Implementation: Design Concepts and Notations,
Functional &Object-Oriented Design Concepts, Design Strategies, Design
specification and verification, Metrics, Design Translation Process.

Unit-5: Software Testing and Reliability: Strategies & Techniques, Debugging,
Software Maintenance, Software Reliability and Availability Models, Software
Reengineering, Cleanroom Approach, Software Reuse. Introduction to IEEE
Standards, Case Studies.
`,
].map((e) => e.trim());

function getSubjectString() {
  const dt = new Date();

  if (dt < new Date(2026, 4, 11, 14, 0, 0)) return SUBJECTS[0];
  if (dt < new Date(2026, 4, 12, 14, 0, 0)) return SUBJECTS[1];
  if (dt < new Date(2026, 4, 13, 14, 0, 0)) return SUBJECTS[2];
  if (dt < new Date(2026, 4, 15, 14, 0, 0)) return SUBJECTS[3];
  if (dt < new Date(2026, 4, 17, 14, 0, 0)) return SUBJECTS[4];
  return null;
}

const PROMPT_TEMPLATE = `You are an expert educational content creator. I want you to generate multiple-choice questions (MCQs) according to the following BCA Subject Syllabus: 

${getSubjectString()}

Please generate exactly 25 questions. The difficulty level of these questions should range from beginner to advanced.  Your response MUST be a valid JSON array of objects, strictly adhering to the following JSON schema:

\`\`\`json;
{
  "type": "array",
    "items": {
    "type": "object",
      "properties": {
      "id": { "type": "string", "description": "A unique identifier for the question (e.g., 'q1')"; },
      "question": { "type": "string", "description": "The MCQ question text"; },
      "options": {
        "type": "array",
          "items": { "type": "string"; },
        "minItems": 2,
          "maxItems": 6,
            "description": "The possible options for the MCQ";
      },
      "codeBlocks": {
        "type": "array",
          "items": { "type": "string"; },
        "minItems": 0,
          "maxItems": 4,
            "description": "The possible codeblocks for the MCQ";
      },
      "correctAnswerIndex": { "type": "integer", "minimum": 0, "description": "The 0-based index of the correct option in the options array"; },
      "explanation": { "type": "string", "description": "A brief explanation of why the correct answer is right"; },
      "difficultyLevel": { "type": "string", "description": "The difficulty level of the question. Use one of the following values: Beginner, Intermediate, Advanced"; }
    },
    "required": ["id", "question", "options", "codeBlocks", "correctAnswerIndex", "explanation", "difficultyLevel"];
  }
}
\`\`\`

Return ONLY the raw JSON output code block. Do not include any conversational text around it.
`;

export function App() {
  const { trigger } = useWebHaptics();

  const [clipBoardAvialable] = useState(Boolean(navigator.clipboard?.readText));
  const [activeTab, setActiveTab] = useState<"setup" | "practice">("practice");

  const [questions, setQuestions] = useState<Question[]>(() => {
    try {
      const saved = localStorage.getItem("mcq-questions");

      const parsed = saved ? JSON.parse(saved) : [];

      if (parsed.length === 0) {
        setActiveTab("setup");
      }

      return parsed;
    } catch (e) {
      console.error(e);

      return DEFAULT_QUESTIONS;
    }
  });
  const [jsonInput, setJsonInput] = useState(() => {
    try {
      const saved = localStorage.getItem("mcq-questions");
      return saved ? saved : JSON.stringify(DEFAULT_QUESTIONS, null, 2);
    } catch {
      return JSON.stringify(DEFAULT_QUESTIONS, null, 2);
    }
  });
  const [jsonError, setJsonError] = useState("");
  const [copiedPrompt, setCopiedPrompt] = useState(false);

  // Quiz State
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [isAnswered, setIsAnswered] = useState(false);
  const [score, setScore] = useState(0);
  const [quizFinished, setQuizFinished] = useState(false);

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const handlePasteAndJsonLoad = async () => {
    try {
      // const parsed = JSON.parse(jsonInput);

      const text = clipBoardAvialable
        ? await navigator.clipboard.readText()
        : typeof jsonInput === "string" && jsonInput
          ? jsonInput
          : "[]";
      console.log(text);

      const parsed = JSON.parse(text);

      if (!Array.isArray(parsed))
        throw new Error("JSON must be an array of questions.");

      // Basic validation
      parsed.forEach((q, i) => {
        if (
          !q.id ||
          !q.question ||
          !Array.isArray(q.options) ||
          typeof q.correctAnswerIndex !== "number"
        ) {
          throw new Error(
            `Invalid format at question index ${i}. Check schema.`,
          );
        }
      });

      setQuestions(parsed);
      localStorage.setItem("mcq-questions", JSON.stringify(parsed));
      setJsonError("");
      resetQuiz();

      if (parsed.length > 0) {
        setActiveTab("practice");
      }
    } catch (e: any) {
      setJsonError(e.message || "Invalid JSON format.");
    }
  };

  const copyPrompt = () => {
    navigator.clipboard.writeText(PROMPT_TEMPLATE);
    setCopiedPrompt(true);
    setTimeout(() => setCopiedPrompt(false), 2000);
  };

  const resetQuiz = () => {
    trigger("heavy");
    setCurrentIndex(0);
    setScore(0);
    setQuizFinished(false);
    setSelectedOption(null);
    setIsAnswered(false);
  };

  const handleOptionClick = (index: number) => {
    if (isAnswered) return;
    setSelectedOption(index);
    setIsAnswered(true);

    if (index === questions[currentIndex]!.correctAnswerIndex) {
      setScore((s) => s + 1);
      trigger("success");
    } else {
      trigger("error");
    }
  };

  // function nextQuestionVibrate() {
  //   trigger("selection");
  // }

  const handleNext = () => {
    trigger("selection");

    if (currentIndex < questions.length - 1) {
      setCurrentIndex((c) => c + 1);
      setSelectedOption(null);
      setIsAnswered(false);
    } else {
      trigger("buzz");
      setQuizFinished(true);
    }
  };

  const currentQ = questions[currentIndex];
  const progress =
    ((currentIndex + (isAnswered ? 1 : 0)) / questions.length) * 100;
  const cardHeightClass = "lg:max-h-[calc(100vh-100px)] lg:overflow-hidden";

  return (
    <div className="min-h-dvh font-sans text-neutral-50 selection:bg-neutral-500/30">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] mask-[radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] bg-size-[14px_24px]" />

      <main className="relative z-10 container mx-auto flex min-h-dvh max-w-4xl flex-col justify-center sm:px-4 sm:pt-6 sm:pb-4">
        <Tabs
          value={activeTab}
          /* @ts-ignore */
          onValueChange={setActiveTab}
          className="flex flex-1 flex-col"
        >
          <div className="mb-5 hidden justify-center">
            <TabsList className="border border-neutral-800">
              <TabsTrigger
                value="practice"
                className="cursor-pointer text-primary! transition-all data-[state=active]:bg-neutral-600"
              >
                <GraduationCap className="mr-2 h-4 w-4" />
                Practice
              </TabsTrigger>
              <TabsTrigger
                value="setup"
                className="cursor-pointer text-primary! transition-all data-[state=active]:bg-neutral-600"
              >
                <FileJson className="mr-2 h-4 w-4" />
                Data Setup
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent
            value="practice"
            className="mt-0 flex flex-1 flex-col duration-500 data-[state=active]:animate-in data-[state=active]:fade-in data-[state=active]:slide-in-from-bottom-2"
          >
            {!quizFinished && currentQ && (
              <div className="mx-auto flex w-full max-w-3xl flex-1 flex-col">
                <Card className="p b-4 flex-1 overflow-hidden rounded-none border-transparent bg-black pt-5 shadow-xl sm:rounded-xl sm:border-neutral-800 sm:bg-neutral-900 sm:pt-6">
                  <CardContent className="p-6 py-0 sm:px-8">
                    <div className="mb-6 flex items-center justify-between">
                      <div className="flex gap-6">
                        <Button
                          variant="outline"
                          size="icon"
                          className="-ml-1 rounded-full text-white"
                          onClick={() => {
                            trigger("light");
                            setActiveTab(
                              activeTab === "practice" ? "setup" : "practice",
                            );
                          }}
                        >
                          {activeTab === "practice" ? (
                            <DoubleLineMenuIcon className="size-[18px]" />
                          ) : (
                            <GraduationCap className="h-6 w-6" />
                          )}
                        </Button>
                        <Badge
                          variant="outline"
                          className="border-neutral-500/30 bg-neutral-500/10 px-3 py-1 font-semibold text-neutral-300"
                        >
                          <span>
                            Ques<span className="desktop">tion</span>{" "}
                            {currentIndex + 1} of {questions.length}
                          </span>
                        </Badge>
                      </div>

                      {/* {score > 0 && <span className="text-sm font-medium text-neutral-400">Score: {score}</span>} */}

                      <div className="flex gap-2">
                        {!isAnswered && (
                          <Button
                            variant="outline"
                            onClick={handleNext}
                            className="shrink-0 rounded-full border-neutral-700 bg-neutral-800/50 px-6 text-neutral-300 hover:bg-neutral-800 hover:text-neutral-100"
                          >
                            Skip
                            <ChevronRight className="ml-2 size-4" />
                          </Button>
                        )}
                        {isAnswered && (
                          // shadow-[0_0_15px_rgba(16,185,129,0.2)]
                          <>
                            <Button
                              variant="default"
                              onClick={handleNext}
                              className="desktop shrink-0 flex-nowrap rounded-full border border-emerald-600 bg-emerald-600/20 px-6 text-emerald-400 hover:bg-emerald-800/20"
                            >
                              {currentIndex < questions.length - 1 ? (
                                <>
                                  Next{" "}
                                  <span className="hidden sm:block">
                                    Question
                                  </span>
                                </>
                              ) : (
                                "Results"
                              )}
                              <ChevronRight className="ml-2 h-4 w-4" />
                            </Button>
                          </>
                        )}

                        {!isFullscreen && (
                          <Button
                            className="fixed bottom-5 left-1 z-10 hidden sm:hidden"
                            variant="ghost"
                            onClick={() => {
                              document.body.requestFullscreen();
                            }}
                          >
                            <Expand className="size-3.5" />
                          </Button>
                        )}
                      </div>
                    </div>

                    {/* <Progress value={progress} className="h-2 mb-8 bg-neutral-800 [&>div]:bg-neutral-500" /> */}

                    {currentQ.codeBlocks.length > 0 && (
                      <div className="pt-0 pb-6">
                        {[currentQ.codeBlocks.join("\n")].map(
                          (codeBlock, index) => (
                            <pre
                              key={index}
                              className="rounded-2xl border border-neutral-500/30 bg-neutral-900 p-4 whitespace-pre-wrap text-primary sm:bg-neutral-800"
                            >
                              <code>{codeBlock}</code>
                            </pre>
                          ),
                        )}
                      </div>
                    )}

                    <div className="mb-8 flex items-start justify-start gap-4">
                      <h2 className="text-[17px] leading-relaxed font-normal text-neutral-100 sm:text-2xl">
                        {currentQ.question}
                      </h2>
                    </div>

                    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                      {currentQ.options.map((opt, i) => {
                        const isSelected = selectedOption === i;
                        const isCorrect = i === currentQ.correctAnswerIndex;
                        const showCorrectness = isAnswered;

                        let btnStyle =
                          "border-neutral-700 bg-neutral-800/50 hover:bg-neutral-800 hover:border-neutral-600 text-neutral-300";
                        let icon = null;

                        if (showCorrectness) {
                          if (isCorrect) {
                            btnStyle =
                              "border-emerald-500/50 bg-emerald-500/10 text-emerald-300 shadow-[0_0_15px_rgba(16,185,129,0.1)]";
                            icon = (
                              <CheckCircle2 className="size-4.5 text-emerald-400" />
                            );
                          } else if (isSelected) {
                            btnStyle =
                              "border-rose-500/50 bg-rose-500/10 text-rose-300";
                            icon = (
                              <XCircle className="size-4.5 text-rose-400" />
                            );
                          } else {
                            btnStyle =
                              "border-neutral-800 bg-neutral-900 text-neutral-500 opacity-50";
                          }
                        } else if (isSelected) {
                          btnStyle =
                            "border-neutral-500 bg-neutral-500/10 text-neutral-300";
                        }

                        return (
                          <button
                            key={i}
                            onClick={() => handleOptionClick(i)}
                            disabled={isAnswered}
                            className={clsx(
                              `flex w-full cursor-pointer items-center justify-between rounded-xl border text-left transition-all duration-300`,
                              btnStyle,
                              isAnswered ? "px-3 py-2 md:px-4 md:py-2" : "p-4",
                            )}
                          >
                            <span className="text-base sm:text-lg">{opt}</span>
                            {icon && (
                              <div className="ml-4 shrink-0">{icon}</div>
                            )}
                          </button>
                        );
                      })}
                    </div>

                    {isAnswered && (
                      <div className="mt-8 mb-30 animate-in rounded-xl border border-sky-500/50 bg-sky-500/15 p-5 text-sky-200 duration-500 fade-in slide-in-from-top-4">
                        <h4 className="mb-2 flex items-center gap-2 text-sm font-semibold tracking-wider text-neutral-50 uppercase">
                          <BrainCircuit className="h-4 w-4" /> Explanation
                        </h4>
                        <p className="leading-relaxed">
                          {currentQ.explanation ||
                            "No explanation provided for this question."}
                        </p>
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
            )}

            {quizFinished && (
              <Card className="absolute top-1/2 right-8 left-8 z-10 flex -translate-y-1/2 animate-in flex-col items-center justify-center rounded-[40px] bg-linear-to-b from-emerald-900/60 to-black py-16 text-center shadow-[0_0px_10px_15px] shadow-emerald-300/40 backdrop-blur duration-500 zoom-in-95 [border:transparent] sm:border-neutral-800 sm:bg-neutral-900/50">
                {/* shadow-[0_0_30px_rgba(16,185,129,0.3)] */}
                <div className="mb-0 flex h-24 w-24 items-center justify-center rounded-full bg-linear-to-b from-emerald-600 to-emerald-800">
                  <CheckCircle2 className="size-16 text-white/70" />
                </div>
                <CardTitle className="mb-2 text-3xl text-neutral-100">
                  Quiz Completed!
                </CardTitle>
                <CardDescription className="mb-5 px-12 text-lg text-neutral-400">
                  You answered <strong className="text-white">{score}</strong>{" "}
                  out of{" "}
                  <strong className="text-white">{questions.length}</strong>{" "}
                  questions correctly.
                </CardDescription>

                <div className="flex flex-col gap-4">
                  <Button
                    size="lg"
                    variant="default"
                    onClick={() => {
                      trigger("heavy");
                      setActiveTab("setup");
                    }}
                    className="rounded-full border-neutral-700 bg-linear-to-b from-emerald-600 to-emerald-800 text-white/90 hover:bg-neutral-800"
                  >
                    <FileText className="mr-2 h-4 w-4" /> New Quiz
                  </Button>

                  <Button
                    size="lg"
                    variant="outline"
                    onClick={resetQuiz}
                    className="rounded-full border-neutral-700 hover:bg-neutral-800"
                  >
                    <RefreshCw className="mr-2 h-4 w-4" /> Try Again
                  </Button>
                </div>
              </Card>
            )}
          </TabsContent>

          <TabsContent value="setup" className="mt-0 flex flex-col gap-6">
            <div className="grid grid-cols-1 gap-6 px-5 py-5 lg:grid-cols-2">
              <Card
                className={clsx(
                  "flex flex-col border-neutral-800 bg-neutral-900 shadow-xl",
                  cardHeightClass,
                )}
              >
                <div className="flex items-start gap-5 px-0 py-1 pr-5">
                  <CardHeader className="-mt-1 w-full gap-0.5">
                    <CardTitle className="flex text-lg text-primary">
                      {/* <Upload className="desktop h-5 w-5 text-emerald-400" /> */}
                      Load Questions
                    </CardTitle>
                    <CardDescription>
                      Paste your generated text here.
                    </CardDescription>
                  </CardHeader>

                  <Button
                    variant="outline"
                    size="icon-lg"
                    onClick={() => {
                      trigger("light");
                      setActiveTab("practice");
                    }}
                    className="rounded-full"
                    // className="flex size-20 cursor-pointer items-center justify-center rounded-full border bg-accent p-2 hover:bg-card"
                  >
                    <X className="size-6 text-neutral-400 lg:size-7" />
                    {/* <ArrowLeft className="size-7 text-neutral-400" /> */}
                  </Button>
                </div>
                <CardContent className="flex flex-0 flex-col gap-4 pb-2">
                  <Textarea
                    onClick={(e) => {
                      e.currentTarget.selectionStart = 0;
                      e.currentTarget.selectionEnd =
                        e.currentTarget.value.length;
                    }}
                    className="sm: max-h-[120px] resize-none scrollbar-none overflow-auto border-neutral-800 bg-neutral-950! p-4 font-mono text-sm text-primary sm:min-h-full sm:flex-1"
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                    placeholder="[{...}]"
                    spellCheck={false}
                  />
                  {jsonError && (
                    <div className="flex items-start gap-2 rounded-lg border border-rose-500/20 bg-rose-500/10 p-3 text-sm text-rose-400">
                      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
                      <p>{jsonError}</p>
                    </div>
                  )}
                  <Button
                    size="lg"
                    onClick={handlePasteAndJsonLoad}
                    className="mt-3 w-full bg-emerald-800 font-semibold text-white transition-all hover:bg-emerald-900"
                  >
                    {clipBoardAvialable ? (
                      <ClipboardPaste className="size-4" />
                    ) : (
                      <Rocket className="size-4" />
                    )}
                    <span>
                      {clipBoardAvialable && <span>Paste & </span>}
                      Start Practice
                    </span>
                  </Button>
                </CardContent>
              </Card>

              <Card
                className={clsx(
                  "flex flex-col border-neutral-800 bg-neutral-900 shadow-xl",
                  cardHeightClass,
                )}
              >
                <CardHeader>
                  <CardTitle className="flex items-center justify-between text-xl">
                    <span className="flex items-center gap-2 text-primary">
                      <BrainCircuit className="h-5 w-5 text-emerald-400" /> AI
                      Prompt
                    </span>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={copyPrompt}
                      className={clsx(
                        "text-neutral-400 hover:bg-neutral-800 hover:text-white",
                        !clipBoardAvialable && "hidden",
                      )}
                    >
                      {copiedPrompt ? (
                        <Check className="mr-2 h-4 w-4 text-emerald-400" />
                      ) : (
                        <Copy className="mr-2 h-4 w-4" />
                      )}
                      {copiedPrompt ? "Copied!" : "Copy Prompt"}
                    </Button>
                  </CardTitle>
                  <CardDescription className="mt-1">
                    Use this system prompt in Claude to generate strictly
                    formatted questions.
                  </CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col overflow-hidden">
                  <div className="flex w-full flex-col overflow-hidden rounded-md border border-neutral-800 bg-neutral-950">
                    <pre className="max-h-[150px] scrollbar-none overflow-auto p-4 font-mono text-sm wrap-break-word whitespace-pre-wrap text-neutral-300 sm:max-h-full">
                      {PROMPT_TEMPLATE}
                    </pre>
                  </div>
                </CardContent>
              </Card>
            </div>
          </TabsContent>
        </Tabs>

        {/* Mobile FAB */}
        <div className="fixed right-6 bottom-6 z-50 sm:hidden">
          {/* <Button 
            size="icon"
            className="h-14 w-14 rounded-full bg-emerald-600 hover:bg-emerald-700 shadow-[0_0_20px_rgba(16,185,129,0.4)] text-white"
            onClick={() => setActiveTab(activeTab === "practice" ? "setup" : "practice")}
          >
            {activeTab === "practice" ? <FileJson className="w-6 h-6" /> : <GraduationCap className="w-6 h-6" />}
          </Button> */}

          {isAnswered && !quizFinished && activeTab === "practice" && (
            <Button
              size="lg"
              className="h-14 w-36 rounded-2xl border-2 border-emerald-600 bg-transparent text-emerald-400 backdrop-blur-md hover:bg-transparent active:bg-emerald-800/30"
              onClick={handleNext}
            >
              <ChevronsRight className="size-9" />
            </Button>
          )}
        </div>
      </main>
    </div>
  );
}

export default App;
